import { Trash } from '@phosphor-icons/react';
import { fmt } from '@/lib/api';
import { cashNumber, cashTotals } from '@/lib/cashReceipts';

const NumberField = ({ id, label, value, onChange, money = false }) => <div>
  <label htmlFor={id}>{label}</label>
  <input id={id} data-testid={id} inputMode="decimal" value={typeof value === 'number' ? value.toLocaleString('nl-BE', { useGrouping: false, minimumFractionDigits: money ? 2 : 0, maximumFractionDigits: 8 }) : value}
    onChange={e => onChange(e.target.value)} onBlur={() => { const n = cashNumber(value); if (typeof value === 'string' && Number.isFinite(n)) onChange(money ? Number(n.toFixed(2)) : n); }} />
</div>;

export const CashLineEditor = ({ line, onChange, onRemove }) => {
  const id = line.regel_id, euro = line.scan_korting_mode === 'euro';
  const change = (key, value) => {
    const changed = { ...line, [key]: value };
    if (key === 'aantal' && line.scan_stuks_per_pack && Number.isFinite(cashNumber(value))) {
      const base = line.omschr.replace(/\s\(-?\d+(?:[.,]\d+)? stuks?(?:; [^)]*)?\)$/, '');
      changed.omschr = `${base} (${cashNumber(value)} stuks)`;
    }
    onChange(changed);
  };
  const discountMode = mode => {
    const gross = Math.abs(cashNumber(line.aantal) * cashNumber(line.prijs));
    onChange({ ...line, scan_korting_mode: mode, korting: mode === 'percent' ? (gross ? cashNumber(line.scan_korting_euro || 0) / gross * 100 : 0) : line.korting,
      scan_korting_euro: mode === 'euro' ? Math.round(gross * cashNumber(line.korting || 0)) / 100 : 0 });
  };
  const net = cashTotals([line]).excl;
  return <div className="cash-editor-line" data-testid={`cash-editor-line-${id}`}>
    <div className="cash-product">
      <strong className="text-sm break-words" data-testid={`cash-line-code-${id}`}>{line.referentie || 'Vrije regel'}</strong>
      <div className="text-xs text-gray-500 break-words" data-testid={`cash-line-description-${id}`}>{line.omschr}</div>
      <div className="text-xs mt-1" data-testid={`cash-line-total-${id}`}>{Number.isFinite(net) ? fmt(net) : '—'} excl. btw</div>
    </div>
    <NumberField id={`cash-qty-${id}`} label={`Aantal (${line.eenheid || 'st'})`} value={line.aantal} onChange={value => change('aantal', value)} />
    <NumberField id={`cash-price-${id}`} label={`Prijs / ${line.eenheid || 'st'}`} value={line.prijs} money onChange={value => change('prijs', value)} />
    <div><div className="flex gap-1 items-end">
      <div className="flex-1 min-w-0"><NumberField id={`cash-discount-${id}`} label="Korting / regel" value={euro ? (line.scan_korting_euro ?? 0) : (line.korting ?? 0)} money={euro} onChange={value => change(euro ? 'scan_korting_euro' : 'korting', value)} /></div>
      <select style={{ width: 46, padding: '8px 2px' }} aria-label="Kortingsvorm" data-testid={`cash-discount-mode-${id}`} value={euro ? 'euro' : 'percent'} onChange={e => discountMode(e.target.value)}><option value="percent">%</option><option value="euro">€</option></select>
    </div></div>
    <div><label htmlFor={`cash-vat-input-${id}`}>Btw</label><select id={`cash-vat-input-${id}`} data-testid={`cash-vat-input-${id}`} value={line.btw} onChange={e => change('btw', Number(e.target.value))}>
      {[...new Set([0, 6, 12, 21, Number(line.btw)])].sort((a, b) => a - b).map(rate => <option key={rate} value={rate}>{rate}%</option>)}
    </select></div>
    <button type="button" className="cash-icon" title="Regel verwijderen" aria-label="Regel verwijderen" onClick={onRemove} data-testid={`cash-remove-line-${id}`}><Trash size={18} /></button>
  </div>;
};